import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const useStyles = makeStyles({
  commentsContainer: {
    paddingTop: 10,
    marginTop: 15,
    display: 'flex',
    alignItems: 'flex-start'
  },
  userContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  textField: {
    marginTop: '.5rem',
    width: '100%'
  },
  commentsInput: {
    borderRadius: 10,
    padding: '13.5px 14px',
    marginLeft: 10
  },
  time: {
    fontFamily: 'PT sans',
    fontSize: '12px',
    color: '#6D7278'
  },
  name: {
    marginTop: 10,
    fontFamily: 'PT sans',
    fontWeight: 'bold',
    fontSize: 14,
    color: '#252525'
  },
  status: {
    marginBottom: 12,
    fontFamily: 'PT sans',
    fontSize: '14px',
    color: '#6D7278'
  }
});

const CommentComponent = ({ name, status, text, avatar, date }) => {
  const classes = useStyles();
  return (
    <div className={classes.commentsContainer}>
      <Avatar className={classes.avatar} src={avatar} />

      <div
        style={{
          background: '#F6F6F6',
          borderRadius: 10,
          width: '100%',
          marginLeft: 5,
          paddingLeft: 20,
          paddingRight: 10
        }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
          <div>
            <Typography className={classes.name} component="h2" variant="h5">
              {name}
            </Typography>
            <Typography className={classes.status}>{status}</Typography>
          </div>
          <Typography className={classes.time} gutterBottom>
            {date}
          </Typography>
        </div>
        <Typography gutterBottom variant="body1">
          {text}
        </Typography>
      </div>
    </div>
  );
};

export default CommentComponent;
